import React, { useEffect, useState, useContext } from "react";
import { Context } from "../../../../utils/context";
import { Parser as HtmlToReactParser } from "html-to-react";
import "./AboutHiclousia.css";

const AboutHiclousia = () => {
  const { getData, imageUrl } = useContext(Context);
  const [ourPartner, setOurPartner] = useState([]);

  const getBlogs = async () => {
    const res = await getData("/without-login/master/all-our-about");
    if (res?.success && Array.isArray(res.data)) {
      setOurPartner(res.data);
    }
  };

  useEffect(() => {
    getBlogs();
  }, []);

  const htmlToReactParser = new HtmlToReactParser();

  return (
    <section className="about-hiclousia-section">
      <div className="container">

      <div className="about-container">
        {/* Section Header */}
        <div className="about-header">
          <span className="about-tag">Who We Are</span>
          <h2>About Us</h2>
          <div className="accent-line"></div>
        </div>

        {/* Dynamic Cards Grid */}
        <div className="about-grid">
          {ourPartner.map((value, index) => (
            <div className="about-card" key={value?.id || index}>
              <div className="about-card-image-wrapper">
                <img
                  src={imageUrl + value?.image}
                  alt={value?.name || "About Us Image"}
                  className="about-card-img"
                  loading="lazy"
                />
              </div>

              <div className="about-card-content">
                <span className="card-number">0{index + 1}</span>
                <h3>{value?.name}</h3>
                <div className="about-description">
                  {htmlToReactParser.parse(value?.description)}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      </div>
    </section>
  );
};

export default AboutHiclousia;